import { render } from "./ImgBienvenida.vue?vue&type=template&id=0b7f5740"
import script from "./ImgBienvenida.vue?vue&type=script&lang=js"
export * from "./ImgBienvenida.vue?vue&type=script&lang=js"

import "./ImgBienvenida.vue?vue&type=style&index=0&id=0b7f5740&lang=css"

import exportComponent from "C:\\Users\\Fernando\\Desktop\\curso Innovaccion Virtual\\FrontEnd\\Practica5 VUE\\pasteleria-vuex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__